import Swal from "sweetalert2";

function showConfirmationDialog(afterAction = () => {}) {
    Swal.fire({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false
    }).then(result => {
        if (result.value) {
            afterAction();
            Swal.fire({
                title: "Deleted!",
                text: "Your file has been deleted.",
                type: "success",
                confirmButtonClass: "md-button md-success",
                buttonsStyling: false
            });
        }
    });
}

export {
    showConfirmationDialog
};